import { render, staticRenderFns } from "./clickAndEdit.vue?vue&type=template&id=0e05356f"
import script from "./clickAndEdit.vue?vue&type=script&lang=js"
export * from "./clickAndEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports